import React from 'react';
import styled, {keyframes} from 'styled-components';
const fadeIn = keyframes`
  from {
    //transform: translateX(-15px); /* 위에서 내려오는 효과를 줍니다. */
    opacity: 0; /* 투명도를 0으로 설정하여 처음에는 보이지 않도록 합니다. */
  }

  to {
    //transform: translateX(0); /* 위치를 변화시켜 아래로 이동합니다. */
    opacity: 1; /* 투명도를 1로 설정하여 완전히 보이도록 합니다. */
  }
`;
const EmptyBox = (props) => {
return(
    <Container>
        <img src={props.url} alt=""/>
        <div className="d-flex flex-column justify-content-center align-items-center">
            <h3>You don’t have any collections.</h3>
            <p className="mb-0">When you create a collection you can find it here.</p>
        </div>
    </Container>
)

}
export default EmptyBox;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-top: 0.6px solid rgba(51, 51, 51, 0.30);
    padding-top: 4rem;
    padding-bottom: 4.2rem;
    gap: 20px;
    animation: ${fadeIn} 0.55s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
    img {
        width: 212.9px;
    };
    h3{
        color: #333;
        text-align: center;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
        font-family: "Europa-Bold";
    }
    p{
        color: #333;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
`;